import { text } from "stream/consumers";
import { TypesColor } from "types/theme";

const commonColor = {
  sidenav: {
    main: "#0A67F3",
    state: "#00B9FF",
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },

  transparent: {
    main: "rgba(0, 0, 0, 0)",
    // main: "transparent",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#00B9FF",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#0A67F3",
      state: "#00B9FF",
    },

    secondary: {
      main: "#343a40",
      state: "#adb5bd",
    },
    success: {
      main: "#ABE098",
      state: "#43CC14",
    },
    error: {
      main: "#F25555",
      state: "#F21818",
    },
    sidenav: {
      main: "#0A67F3",
      state: "#00B9FF",
    },
    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },
  },
  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#00a556",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#FE2626",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },
};

export const colorsDark: TypesColor = {

  blue: {
    light: '#4F89D6',
    main: '#0052A3',
    dark: '#00377133',
    darker: '#001e3e'
  },

  transparent: {
    main: commonColor.transparent.main,
  },
  black: {
    light: commonColor.black.light,
    main: commonColor.black.main,
    focus: commonColor.black.focus,
  },

  grey: commonColor.grey,
  coloredShadows: commonColor.coloredShadows,
  inputBorderColor: commonColor.inputBorderColor,
  tabs: commonColor.tabs,
  sidenav: commonColor.sidenav,
  badgeColors: commonColor.badgeColors,

  background: {
    default: "#121212",
    sidenav: "#404040",
    sidenavDark: "#121212",
    card: "#292929",
    paper: "#121212",
  },

  backgroundLight: {
    primary: "#F3F8FF",
    secondary: "#FFFFFF",
    sidenav: "#E4EDFF",
    sidenavBorder: "#83B9F9",
    sideNavBG: "#E4EDFF",
    sideNavHighlightBG: "#003771",
    sideNavLogoBg: "#DAE3F4",
    sideNavBgHover: "#EFF6FF",
    sideNavExpandBg: "#DAE3F4",
    globalSearch: "#004894",
    globalSearchBorder: "#39ACE7",
    globalSearchPlaceHolder: "#FFFFFF",
    dark: "#003771",
    icon: "#39ACE7",
  },

  textLight: {
    main: "#000000",
    secondary: "#0784B5",
    dark: "#003771",
    light: "#FFFFFF",
    sideNavMain: "#39ACE7",
    sideNavDark: "#003771",
  },

  Header: {
    background: "#003771",
    text: "#FFFFFF",
    textSecondary: "#a9adcb", // local time color
    userMenuBg: "#003771",
    UserMenuAvatarBg: "#0079A6",
    UserMenuAvatarText: "#FFFFFF",
    TabPagerHeaderBg: "#F3F8FF",
    TabPageHeaderBorder: "#003771"
  },

  page: {
    title: "#003771"
  },

  landingPageTile: {
    background: "#003771",
    listBackground: "#E4EDFF",
    listitemColor: "#003771",
    text: "#ffffff",
    parentTagline: "rgba(255,255,255,0.7)",
    ExpandIcon: "#ffffff",
    divider: "#003771",
    iconColor: "#02355A"
  },

  landingPage: {
    welcomeText: "#003771",       // "Welcome aboard, Power User All"
    subtitleText: "#0784B5",      // "Your PepWise journey starts here!"
    labelText: "#0784B5",         // "User Role", "Sector", "Last Login"
    valueText: "#003771",         // "PepWise System User", "All", date/time
    divider: "#003771",           // Thin line below "Recently Used Dashboards"
    sectionTitle: "#003771",      // "Recently Used Dashboards"
  },

  scrollbar: {
    background: "#f1f1f1",
    thumb: "#003771",
  },

  dropdown: {
    background: "#003771",
    bgColorDisabled: "rgba(113, 117, 143, 0.05)",
    menuItemBackground: "#E4EDFF",
    menuItemText: "#003771",
    menuItemHover: "#003771",
    menuItemHoverText: "#FFFFFF",
    menuItemSelected: "#005092",
    checkBox: "#009BD8",
    border: "#003771"
  },

  queryBuilder: {
    background: '#FBFDFF',
    tableCellBackground: '#FFFFFF',
    text: '#000000',
    title: '#00366E',
    subText: '#71758F',
    primary: '#009BD8',
    cardBackground: '#EFF6FF',
    dropdown: {
      background: '#EFF6FF',
    }
  },

  // used for new more options menu
  moreOptionDropdown: {
    background: "#EFF6FF",
    menuItemBackground: "#E4EDFF",
    menuItemText: "#000",
    menuItemHover: "#39ACE733 ",
    menuItemHoverText: "#000",
    deleteMenuItem: "#FE2626",
    chipBackground: "#39ACE733",
    chipText: "#003771",
  },

  DropdownV2: {
    background: "#E4EDFF",
    menuTextColor: "#000",
    menuItemBackground: "#FFFFFF",
    menuItemText: "#000",
    menuItemSelectedBg: "#39ACE733",
    menuItemSelectedText: "#000",
    menuItemHover: "#F4F6F8 ",
    menuItemHoverText: "#000",
    tickColor: '#003771',
    borderColor: '#71758FCC',
    borderColorActive: '#39ACE7',
    borderColorHover: '#39ACE7',
    dropdownIconDefault: '#39ACE7',
    dropdownIconActive: '#003771',
    mutedText: '#A9ADCB'
  },

  filterDropdown: {
    label: "#000000",
    title: "#003771",

    fieldText: "#003771",
    fieldPlaceholder: "#000000",
    fieldBackground: "#EFF6FF",
    fieldBorder: "#D8E3F2",
    fieldIcon: "#39ACE7",
    fieldClearIcon: "#39ACE7",

    panelBackground: "#FFFFFF",
    panelBorder: "#D8E3F2",

    searchIcon: "#5B6B82",
    searchText: "#003771",
    searchPlaceholder: "#5B6B82",
    searchBackground: "#FFFFFF",

    optionText: "#003771",
    optionHoverBackground: "#EEF5FF",

    checkboxBorder: "#39ACE7",
    checkboxCheck: "#39ACE7",
    checkboxBackground: "transparent",

    chipBackground: "#39ACE733",
    chipText: "#003771",

    emptyText: "#5B6B82",
  },

  checkboxGroup: {
    title: "#003771",
    optionText: "#000000",
    checkboxBorder: "#39ACE7",
    checkboxCheckedBackground: "#39ACE7",
    checkboxCheckIcon: "#FFFFFF",
    checkboxUncheckedBackground: "transparent",
    disabledBorder: '#A9ADCB',
  },

  radioGroup: {
    title: "#003771",
    optionText: "#000000",
    radioBorder: "#39ACE7",
    radioCheckedBackground: "#39ACE7",
    radioCheckIcon: "#FFFFFF",
    radioUncheckedBackground: "transparent",
    disabledBorder: '#A9ADCB',
  },

  filterPanel: {
    panelBackground: "#FFFFFF",
    panelBorder: "rgba(0,0,0,0.08)",
    panelShadow: "0px 10px 30px rgba(0,0,0,0.12)",
    headerTitle: "#00366E",
    sectionTitle: "#003771",
    footerBackground: "#FFFFFF",
    clearButtonText: "#39ACE7",
    applyButtonBackground: "#39ACE7",
    applyButtonHoverBackground: "#1C78C2",

    triggerClearText: "#FFA200",
    triggerBadgeText: "#FFFFFF",
  },

  dateFilter: {
    triggerHoverBackground: "#D4ECFA",
    triggerText: "#39ACE7",
    triggerTextActive: "#003771",

    popoverBackground: "#FFFFFF",
    popoverText: "#000000",
    popoverBorder: "#E6E6E6",
    popoverShadow: "0 4px 18px rgba(0,0,0,0.15)",

    presetPanelBackground: "#FBFDFF",
    presetText: "#000000",
    presetHoverBackground: "#39ACE733",
    presetSelectedBackground: "#39ACE733",
    presetArrow: "#39ACE7",

    calendarBackground: "#EFF6FF",
    calendarHeaderText: "#000000",
    weekDayText: "#000000",

    rangeBackground: "#39ACE7",
    dayText: "#000000",
    dayTextInRange: "#FFFFFF",
    dayHoverBackground: "#D4ECFA",
    dayHoverText: "#000000",
  },

  search: {
    background: "#004894",
  },

  accordion: {
    InsightsBg: "#EFF6FF",
    bg: "#E4EDFF",
  },
  modal: {
    bg: "#EFF6FF",
    text: "#000000",
    subTitle: "#003771",
    // new colors for pepwise 2.0 modal
    titleBg: "#003771",
    sectionTitle: "#39ACE7",
    searchIconColor: "#003771",
    title: "#FFFFFF",
    background: "#FFFFFF"
  },
  overlay: {
    // new colors for pepwise 2.0 overlay
    title: "#00366E",
    IconColor: "#00366E",
    border: "#71758FCC",
    background: "#FFFFFF"
  },
  input: {
    border: "#000000",
    text: "#000000",
    borderFocus: "#003771",
  },

  // This is for the new input fields in the pepwise 2.0
  inputNew: {
    inputBackground: '#EFF6FF',
    inputBorder: '#71758FCC',
    inputBorderHover: '#39ACE7',
    inputBorderFocus: '#39ACE7',
    inputIcon: '#39ACE7',
    inputText: '#000000',
    inputPlaceholder: '#71758F',
    labelText: '#000000',
    addText: '#39ACE7',
    saveBackground: '#39ACE7',
    saveText: '#FFFFFF',
    removeBorder: '#FE2626',
    removeHoverBackground: '#FE262733',
    removeIcon: '#FE2626',
    error: '#FE2626',
  },

  // This is for the new toggle in the pepwise 2.0
  toggle: {
    text: '#003771',
    thumb: '#FFFFFF',
    trackOff: '#71758F',
    trackOn: '#39ACE7',
    disabledTrack: '#A9ADCB',
    thumbShadow: '0px 1px 3px rgba(0, 0, 0, 0.25)',
  },

  chip: {
    activeBg: "#01C00826",
    inactiveBg: "#D82B5133",
    textPrimary: "#000000",
  },

  richTextEditor: {
    icons: {
      primary: "#0784B5",
    }
  },

  buttons: {
    primary: {
      color: "#009BD8", // used in modals
      bgColor: "#0784B5",
      bgColorSecondary: "#003771", // used in create alerts
      text: "#FFFFFF",
      // pepwise 2.0 button colors
      solidBg: '#39ACE7',
      solidText: '#FFFFFF',
      solidHoverBg: '#009BD8',
      borderedText: '#009BD8',
      borderedBorder: '#009BD8',
      borderedHover: '#003771',
      borderedHoverText: '#003771',
      textColor: '#009BD8',
      textHover: '#003771',
      disabledBg: '#A9ADCB',
      disabledSolidText: '#D9D9D9',
      disabledText: '#A9ADCB',
      disabledBorder: '#A9ADCB',
      deleteButtonBg: '#D82B51',
    }
  },

  Tab: {
    Active: {
      bgColor: "#004894",
      color: "#ffffff",
      colorSecondary: "#003771",

      newBgColor: "#ffffff",
      newColor: "#009BD8",
      newBorderColor: "#009BD8"
    },

    inActive: {
      bgColor: "#003771",
      color: "#A6ABCA ",
      colorSecondary: "#009BD8",

      newColor: "#ffffff",
    }
  },

  dataPipeline: {
    accordionWidget: {
      accordionHeader: {
        background: '#FBFDFF',
        text: '#000000',
        tooltipBackground: '#FFFFFF',
        tooltipText: '#000000',
        tooltipTitle: '#71758F',
        tooltipArrow: '#FFFFFF',
        comingSoonBackground: '#A9ADCB',
        comingSoonBorder: '#A9ADCB',
        legendText: '#71758F',
        expandIconActive: '#000000',
        expandIconInactive: '#39ACE7',
      },
      background: {
        page: '#F3F8FF',
        card: '#FFFFFF',
        tooltip: '#EFF6FF',
        statusMuted: '#A9ADCB',
        runningDayActive: '#003771',
        timelineBar: '#003771',
        timelineDotBorder: '#FFFFFF',
        timelineDotRing: '#00000033',
        timelineConnector: '#FFFFFF',
      },
      text: {
        primary: '#000000',
        secondary: '#71758F',
        inverse: '#FFFFFF',
        link: '#39ACE7',
        tooltipPrimary: '#003771',
      },
      border: {
        subtle: '#D3D7DE',
        muted: '#A9ADCB',
        runningDay: '#003771',
        expandedAccordion: '#39ACE7',
      },
      pagination: {
        iconActive: '#39ACE7',
        iconDisabled: '#A9ADCB',
        pageActiveBackground: '#71758F33',
        pageActiveText: '#39ACE7',
        pageDefaultText: '#39ACE7',
        pageHoverBackground: '#71758F33',
      },
      timelineTooltip: {
        background: '#EFF6FF',
        text: '#000000',
        shadow: '0px 8px 24px #00000033',
      },
    },
  },

  widget: {
    text: {
      main: '#000000',
      title: '#000000',
      value: '#000000',
      changeUp: '#D82B51',
      changeDown: '#01C008',
      noChange: '#71758F',
      duplicateCount: '#FFA200',
      action: {
        primary: '#009BD8',          // ADD PROJECT text/icon + link hover
        primaryHover: '#009BD8',     // (same for now, keep for future flexibility)
      },
    },
    background: {
      card: '#ffffff',
      chart: '#ffffff',
    },
    chart: {
      emptyCircleFill: '#71758f66',
      labelColor: '#FFFFFF', // piechart label
      legendTextColor: '#71758F',
      legendActiveUpDownIconColor: '#71758F',
      legendInactiveUpDownIconColor: '#A7ADCB',
      tooltipBg: '#FFFFFF',
      tooltipText: '#000000',
      labelColorSecondary: '#000000', // barchart label
    },
    gaugeChart: {
      filledArcColor: "#299BFF",
      unfilledArcColor: "#E4EDFF",
    },
    colors: {
      color1: "#00B4C5",
      color2: "#00BF7D",
      color3: "#F57600",
      color4: "#F5359E",
      color5: "#FF6B55",
      color6: "#8BABF1",
      color7: "#1F4E79",
      color8: "#3FA9F5",
      color9: "#A6C8E1",
      trendLine: "#FDB515"
    },
    tab: {
      activeBorderColor: "#12386D",
      inActiveBorderColor: "#5A97BF ",
      active: {
        color: "#003771",
      },
      inActive: {
        color: "#39ACE7 ",
      }
    },
    filter: {
      bgColorPrimary: '#fff',
      bgColorSelected: '#12386D',
      textSelected: '#fff',
      textPrimary: '#5A97BF',
      border: '#5A97BF',
    },
    sla: {
      missed: {
        bg: '#D82B51',
        hoverBg: 'rgb(189, 29, 64)',
      },
      met: {
        bg: '#01C008',
        hoverBg: 'rgb(3, 168, 8)',
      },
      scheduled: {
        bg: '#A9ADCB',
        hoverBg: 'rgba(163, 168, 200, 1)',
      },
      progress: {
        bg: '#ECB914',
        hoverBg: 'rgba(236, 185, 20, 1)',
      },
      others: {
        bg: '#ECB914',
        hoverBg: 'rgb(220, 171, 10)',
      },
      text: '#FFFFFF', // SLA button text color
    },
  },

  KpiSeverityWidget: {
    severity: {
      critical: '#F04438',
      major: '#F79009',
      minor: '#EAAA08',
      warning: '#FFCC00',
      info: '#2E90FA',
      healthy: '#01C008',
      Acknowledged: "#A9ADCB",
      Unacknowledged: "#9498B5"

    },

    card: {
      background: '#FFFFFF',
      highlightBackground: '#003771',
      border: 'rgba(0, 0, 0, 0.12)',
      shadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
      hoverShadow: '0 4px 14px rgba(0, 0, 0, 0.10)',
    },

    text: {
      primary: '#0A0A0A',
      secondary: '#BAB5B5',
      muted: '#888888',
      disabled: '#CCCCCC',
      highlight: '#FFFFFF',
      highlightSecondary: 'rgba(255, 255, 255, 0.70)',
      highlightMuted: 'rgba(255, 255, 255, 0.65)',
      link: '#43A5F0',
    },

    alertRow: {
      background: 'rgba(0, 0, 0, 0.04)',
      highlightBackground: '#003771',
      platformHighlightBackground: 'rgba(255, 255, 255, 0.12)',
    },

    kpi: {
      background: '#F0F4FA',
      highlightBackground: '#003771',
    },

    segment: {
      background: '#FFFFFF',
      highlightBackground: 'rgba(255, 255, 255, 0.08)',
      border: 'rgba(0, 0, 0, 0.06)',
      highlightBorder: 'rgba(255, 255, 255, 0.15)',
      text: '#FFFFFF',
    },

    dialog: {
      background: '#FFFFFF',
      title: '#FFFFFF',
      closeIcon: '#FFFFFF',
    },
  },

  bannerColors: {
    info: {
      background: '#E6F0FA',
      text: '#000000',
      accent: '#7891B2',
      buttonBackground: '#E6F0FA',
      buttonHoverBackground: '#BDD8F1',
      buttonBorder: '#003771',
    },
    success: {
      background: '#E3F3E9',
      text: '#000000',
      accent: '#54AD81',
      buttonBackground: '#E3F3E9',
      buttonHoverBackground: '#B3DEC5',
      buttonBorder: '#003771',
    },
    warning: {
      background: '#FFF3DE',
      text: '#000000',
      accent: '#EFA865',
      buttonBackground: '#FFF3DE',
      buttonHoverBackground: '#F4CF8D',
      buttonBorder: '#003771',
    },
    critical: {
      background: '#FCE8E8',
      text: '#000000',
      accent: '#F47781',
      buttonBackground: '#FCE8E8',
      buttonHoverBackground: '#F1B1BA',
      buttonBorder: '#003771',
    },
  },

  kpiTile: {
    text: {
      main: '#000000',
      title: '#000000',
      value: '#002043',
      changeUp: '#D82B51',
      changeDown: '#01C008',
      noChange: '#71758F'
    },
    background: {
      card: '#F3F8FF',
      selected: '#009BD8',
      border: '#CAE9F5',
      hover: '#E4EDFF',
      changeUp: '#FFC5C2',
      changeDown: '#AEFFB8',
      steady: '#FFEAC6'

    },
  },

  tooltip: {
    text: {
      primary: '#000000',
      title: '#000000',
      description: '#71758F',
    },
    background: {
      primary: '#EFF6FF',
    },
    button: {
      BgColor: '#009BD8',
      textPrimary: '#ffffff',
      textSecondary: '#003771',
    },
    progressDot: {
      primary: '#009BD8', // active
      secondary: '#D0D0D0', // inactive
    }
  },

  table: {
    headerText: '#FFFFFF',
    text: '#000',
    title: '#000',
    headerBg: '#003771',
    oddRowBgColor: '#FFFFFF',
    evenRowBgColor: '#E4EDFF',
    moreIcon: '#009BD8',
    highlightRowBgColor: '#71758F33',
    checkBox: '#39ACE7',
    chipBackground: "#00377133",
    chipText: "#003771",
    expandIcon: "#003771",
    pagination: {
      text: '#000',
      pageSizeText: '#39ACE7',
      BgColor: '#E4EDFF',
      arrow: '#000',               // Arrow (next/prev, first/last) color
      selectedText: '#000000',        // Text color for selected page
      selectedBackground: '#71758F33',// Background for selected page
      hoverBackground: '#71758F33',   // Background on hover
    }
  },

  toast: {
    success: {
      title: '#01C008',
      icon: '#01C008',
    },
    alert: {
      title: '#F58A1F',
      icon: '#FD9532',
    },
    error: {
      title: '#FF3B30',
      icon: '#FB3836',
    },
    background: '#EFF6FF',
    message: '#001E3E',
    closeIcon: '#001E3E',
  },

  login: {
    background: {
      default: "#003771",
      textFieldBackground: "rgba(255, 255, 255, 0.5)",
      button: "#39ACE7",
    },
    text: {
      main: "#FFFFFF",
      tagLine: "#E5E5E5",
      forgot: "#39ACE7",
    },
  },

  white: {
    main: "#ffffff",
    button: "#ffffff",
    srch: "#000000",
    focus: "#00B9FF",
  },
  text: {
    subtle: '#a9adcb',
    main: "#E5E5E5",
    focus: "#00B9FF",
    dark: "#121212",
  },
  primary: {
    main: "#003771",
    focus: "#0079A6",
    dark: '#122950',
  },

  secondary: {
    main: "#00B9FF",
    focus: "#990F0F",
  },

  info: {
    main: "#00B9FF",
    focus: "#32990F",
  },

  success: {
    light: '#00d08d',
    main: "#00a556",
    focus: "#00B9FF",
    state: "#43CC14",
  },

  warning: {
    main: "#fd7b33",
    focus: "#fd7b33",
  },

  error: {
    light: "#EDC2C2",
    main: "#FE2626",
    focus: "#F21818",
  },

  light: {
    main: "#8c8c8c",
    diff: "#BCBCBC",
    focus: "#00B9FF",
    unselected: "#8c8c8c",
  },

  dark: {
    main: "#8C8C8C",
    focus: "#00B9FF",
    unselected: "#8c8c8c",
    helpBorder: "#fff",
    background: "#121212",
    text: "#404040",
    dark: "#A9ADCB33",
  },
  gradients: {
    primary: commonColor.gradients.primary,
    secondary: commonColor.gradients.secondary,
    success: commonColor.gradients.success,
    sidenav: commonColor.gradients.sidenav,
    error: commonColor.gradients.error,
    info: {
      main: "#0A68F3",
      state: "#00B9FF",
    },
    warning: {
      main: "#8ce0ff",
      state: "#8ce0ff",
    },
    light: {
      main: "#fdc4a4",
      state: "#f0ae89",
    },

    dark: {
      main: "#8c8c8c4d",
      state: "#2929294d",
    },
  },
  boxColor: {
    green: {
      color: 'rgb(70, 254, 77)',
      bgColor: '#01C008',
    },
    greenTrend: {
      color: 'rgb(72, 189, 145)',
      bgColor: 'rgba(1, 154, 6, 0.2)',
    },
    red: {
      color: 'rgb(254, 52, 52)',
      bgColor: '#FE2626',
    },
    redTrend: {
      color: 'rgb(254, 52, 52)',
      bgColor: 'rgba(181, 1, 1, 0.2)',
    },
    orange: {
      color: 'rgb(255, 171, 26)',
      bgColor: 'rgba(204, 130, 0, 0.7)',
    },
    orangeDark: {
      color: 'rgba(253, 120, 59, 1)',
      bgColor: 'rgba(253, 120, 59, 0.7)',
    },
    blue: {
      color: 'rgb(54, 168, 255)',
      bgColor: 'rgba(0, 96, 179, 0.7)',
    },
    gray: {
      color: 'rgb(163, 178, 199)',
      bgColor: 'rgba(50, 54, 83, 0.7)',
    },
    default: {
      color: 'rgba(169, 173, 203)',
      bgColor: 'rgba(169, 173, 203, 0.2)',
    },
    paleYellow: {
      color: 'rgba(252, 192, 70, 1)',
      bgColor: '#ECB914'
    },
    paleRed: {
      color: 'rgba(255, 137, 137, 1)',
      bgColor: '#FF9B5D'
    },
    paleGray: {
      color: 'rgba(169, 173, 203, 1)',
      bgColor: '#71758F'
    },
    lime: {
      color: 'rgba(183, 207, 72, 1)',
      bgColor: 'rgba(183, 207, 72, 0.7)'
    },
    pgmGreen: {
      color: 'rgba(1, 192, 8, 1)',
      bgColor: '#01C008'
    },
    pgmPink: {
      color: 'rgba(216, 43, 81, 1)',
      bgColor: '#FE2626'
    },
    pgmYellow: {
      color: 'rgba(236, 185, 20, 1)',
      bgColor: '#ECB914'
    },
    totalStages: {
      color: 'rgba(41, 155, 255, 1)',
      bgColor: 'rgba(0, 55, 111, 1)'
    },
    scheduled: {
      color: 'rgba(113, 117, 143, 1)',
      bgColor: 'rgba(169, 173, 203, 1)'
    },
    slaMet: {
      color: 'rgba(0, 128, 5, 1)',
      bgColor: 'rgba(1, 192, 8, 1)'
    },
    slaMissed: {
      color: 'rgba(189, 29, 64, 1)',
      bgColor: 'rgba(254, 38, 38, 1)'
    },
    inProgress: {
      color: 'rgba(176, 136, 0, 1)',
      bgColor: 'rgba(236, 185, 20, 1)'
    },
    failedToStart: {
      color: 'rgba(123, 84, 241, 0.7)',
      bgColor: 'rgba(160, 129, 255, 1)'
    },
    delayedStart: {
      color: 'rgba(253, 120, 59, 0.7)',
      bgColor: 'rgba(255, 155, 93, 1)'
    },
    purple: {
      color: 'rgba(160, 129, 255, 1)',
      bgColor: '#A081FF'
    },
    solidBlue: {
      color: 'rgba(41, 155, 255, 1)',
      bgColor: '#299BFF'
    },
    pgmGray: {
      bgColor: '#A9ADCB',
      color: 'rgba(169, 173, 203, 1)',
    }
  },
};
